import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M9 12h-3.586a1 1 0 0 1 -.707 -1.707l6.586 -6.586a1 1 0 0 1 1.414 0l6.586 6.586a1 1 0 0 1 -.707 1.707h-3.586v6h-6v-6","key":"svg-0"}],["path",{"d":"M9 21h6","key":"svg-1"}]]

const IconArrowBigUpLine = createReactComponent('outline', 'arrow-big-up-line', 'ArrowBigUpLine', __iconNode);

export default IconArrowBigUpLine;